import { useSelector } from '@xstate/react';
import { Navigate, useLocation } from 'react-router';
import type { ActorRefFrom } from 'xstate';
import { readRegistrationReturnTo } from '~/routing/registrationReturnTo';
import { buildAuthCompletePath } from '~/routing/returnTo';
import { Container, FormContent, Header } from '../components/Layout';
import { providerRegistrationView } from '../registration-view.machine';
import type { RegistrationViewContext } from '../types';

interface PageProps {
  actorRef: ActorRefFrom<typeof providerRegistrationView>;
  viewContext: RegistrationViewContext;
}

export function RegistrationCompletePage({ actorRef, viewContext }: PageProps) {
  const firstName = useSelector(actorRef, (s) => s.context.typeAndCategoryForm.firstName);
  const location = useLocation();
  const isCompleted = useSelector(actorRef, (state) => state.matches('$_COMPLETED'));

  if (isCompleted) {
    return (
      <Navigate to={buildAuthCompletePath(readRegistrationReturnTo(location.search))} replace />
    );
  }

  return (
    <Container>
      <Header title="Registration Complete!" subtitle={`Welcome, ${firstName || 'Provider'}!`} />

      <FormContent>
        <div className="flex flex-col items-center justify-center h-full text-center">
          <svg
            className="w-20 h-20 text-success mb-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l4 4L19 7" />
          </svg>
          <p className="text-lg text-grey-300">
            Your provider registration has been successfully submitted.
          </p>
        </div>
      </FormContent>
    </Container>
  );
}
